<template>
  <b-card
      border-variant="dark"
      title="گزارش جسمانی"
  >
    <b-card-body >
      <b-overlay
          :show="loading"
          rounded="sm"
      >
        <b-row>
          <b-col
              v-for="item in statisticsItems"
              xl="2"
              md="auto"
              sm="6"
              class="mt-2"
          >
            <b-media
                no-body
            >
              <b-media-aside
                  class="mr-1"
              >
                <b-avatar
                    size="40"
                    :variant="item.color"
                >
                  <feather-icon
                      size="20"
                      :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title  }}
                </h4>
                <b-card-text class="font-small-3 mb-0" style="font-size: 12px !important;">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  name: 'EcommerceStatistics',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props:{
    UserId: {
      type: [String,Number],
      default:'',
    },
  },
  data() {
    return {
      loading: false,
      statisticsItems: []
    }
  },
  created() {
    this.setReports()
  },
  methods: {
    setReports() {
      this.loading = true
      this.$http.get(this.$api.user.userbodyhistory,{
        params:{UserId:this.UserId}
      }).then(response => {
        this.statisticsItems = response.data.WeightDetails.map(i=>(
        {
          icon: 'ClipboardIcon',
          color: 'light-primary',
          title: i.Value,
          subtitle: i.Text,
        }
        ))
      }).finally(() => this.loading = false)
    },
  },
}
</script>
